import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

interface IProps {
    onChange: (dates: any, dateStrings: any) => void
    disabledDate?: (current: any) => any
}

export default function DatePickerCustom({ onChange, disabledDate }: IProps) {
    return (
        <>
            <RangePicker
                defaultValue={[dayjs(), dayjs()]}
                presets={[
                    { label: "Aujourd'hui", value: [dayjs(), dayjs()] },
                    { label: 'Ce mois', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                ]}
                onChange={onChange}
                disabledDate={disabledDate || undefined}
            />
        </>
    );
}
